// extracted by mini-css-extract-plugin
module.exports = {"profile":"TEr0i","avatar":"_7Wl7V","link":"N+MSp","label":"PKejY","row":"zD5+K","options":"_0PUZQ"};